/* eslint-disable no-irregular-whitespace */
import React, { memo } from 'react';
import { unlimitedDocsFakedoorConfig } from 'reactApp/appHelpers/featuresHelpers/features/unlimitedDocuments';
import { getUnlimitedDocumentsTypeNameGenitive } from 'reactApp/modules/unlimitedDocuments/unlimitedDocuments.const';

import styles from './UnlimitedDocumentsNote.css';

export const UnlimitedDocumentsNote = memo(() => {
    const typeNameGenitive = getUnlimitedDocumentsTypeNameGenitive(unlimitedDocsFakedoorConfig.type);
    return (
        <div className={styles.footer}>
            <span data-qa-id="note">Хранить можно до 5 ТБ {typeNameGenitive} — независимо от объёма тарифа</span>
        </div>
    );
});

UnlimitedDocumentsNote.displayName = 'UnlimitedDocumentsNote';
